export default __webpack_public_path__ + "2da00914e9eff8ae1d061ad8eb033961.ttf";